module.exports = __webpack_public_path__ + "static/HBR_TipOfTheDay-4d9a32745ed74442811a46345d4b3b34.mp4";